import { QueryKey } from "@tanstack/react-query";

import { ServicePath } from "../../constants/apiConstants";
import { useFetchQuery, FetchQueryParams, getFetchQuery } from "../core/rest/useFetchQuery";
import { UserGroupsMembersQueryResult } from "./user.types";

const getUserGroupsMembersQueryParams = (
  userGroupId: string,
): {
  queryKey: QueryKey;
  url: string;
  options: FetchQueryParams<UserGroupsMembersQueryResult, UserGroupsMembersQueryResult>["options"];
} => ({
  queryKey: ["userGroups", "members", userGroupId],
  url: `${ServicePath.AccessGroupV1}/groups/${userGroupId}/members`,
  options: { enabled: !!userGroupId },
});

export const getUserGroupsMembersQuery = (userGroupId: string) => {
  return getFetchQuery<UserGroupsMembersQueryResult>({
    ...getUserGroupsMembersQueryParams(userGroupId),
  });
};

export function useGetUserGroupsMembers(userGroupId: string) {
  return useFetchQuery<UserGroupsMembersQueryResult>({
    ...getUserGroupsMembersQueryParams(userGroupId),
  });
}
